const getPartners = state => state.partners;
export default { getPartners };
